import React from 'react'
import { Support } from '../components/Support'
import { Footer } from '../components/Footer'
import { Banner2 } from '../components/Banner2.js'

export function About() {
    return (
        <div>
            <Support />
            <Banner2 />
            <Footer />
        </div>
    )
}


